let resumeData = {
   
  "name": "Mansi Sahu",
  "role": "Software Developer",
  "mailId": "sahumansi7569@gmail.com",
  "contactNumber": "+91 6268797569",
  "skypeid": "https://www.linkedin.com/in/mansi-sahu-1354b630a",
  "roleDescription": "I like dabbling in various parts of frontend development and like to learn about new technologies, write technical articles or simply play games in my free time.",
  "socialLinks": [
    {
      "name": "linkedIn",
      "url": "https://www.linkedin.com/in/mansi-sahu-1354b630a",
      "className": "fa fa-linkedin"
    },
    {
      "name": "intagram",
      "url": "https://www.instagram.com/man_shi_sahu_23?utm_source=qr&igsh=MXhId3phOHkwajRrZA==",
      "className": "fa fa-instagram"
    },
    {
      "name": "Github",
      "url": "https://github.com/Mansi226-ux",
      "className": "fa fa-github"
    }
  ],
  "aboutme": "I am currently a pre-final year student at The DAVV University and pursuing my MSC from here. I am a self taught frontend Web Developer, currently diving deeper into Backend  Learning. I believe that to be successful in life, one needs to be obsessive with their dreams and keep working towards them.",
  "address": "Pune, Maharashtra",
  "website": "https://showingskills-6242bfs.netlify.app/#home",
  "education": [
    {
      "UniversityName": "Government Holkar Science College, Indore",
      "specialization": "M.Sc in Computer Science",
      "MonthOfPassing": "july",
      "YearOfPassing": "2026",
      "Achievements": " Awarded the university’s Distinguished Research Grant for innovative projects on renewable energy resources."
    },
    {
      "UniversityName":"Government Holkar Science College, Indore",
      "specialization":"B.Sc in Computer Science",
      "MonthOfPassing":"July",
      "YearOfPassing":"2024",
      "Achievements":" Awarded the university’s Distinguished Research Grant for innovative projects on renewable energy resources."
    }
  ],
  "work": [
     
      {
        "CompanyName":"Zidio Develelopment Pvt Ltd",
         "specialization": "Frontend Development Intern",
        "MonthOfLeaving":"May 2025 - Aug2025",
        "Achievements":"During my internship, I had the opportunity to work on two major full-stact projects that helped me grow both technicall and professionally. Excel Analytics platform i built a compelete ata visualization like file upload & parsing using Node.js and xlsx Real-time 2D/3D chart rendering using chart.js and Three.js, Exporting charts as PNG, JPEG and PDF AI-based suggestions  from structured data. * Blogging Platform (Voxa Blog) i developed a full-featured blogging system with rich content creation and social features like Authentication using JWT and role-based access control image uploads using Cloudinary and content editing with  React-Quill Like, Comment, and Profile systems for user engagement."
      },
    {
      "CompanyName": "Ypsilon IT Solution",
      "specialization": "Web Development Intern(MERN Stack)",
      "MonthOfLeaving": "Aug 2024 - Oct 2024",
      
      "Achievements": "Developed REST fullservices using Node.js and Express, integrating JSON Web Token for secure authorization mechanisms.  *Designed and tested UI Component for web applications, utilizing HTML, CSS, JavaScript, BootStrap and React JS  to enhance user experience.  *Validate input before submitting to the backend.  *Translated user and business needs into functional front - end design using Javascript, HTML, and CSS.  *Worked on the development of user interface for Stealth(identity) from scratch."
    }
      
    ],
"skillsDescription": "My skills here",
  "skills": [
     {
      "skillname": "html"
    },
    {
      "skillname": "css"
    },
    {
      "skillname": "javascript"
    },{
      "skillname": "Python"
    },
    {
      "skillname": "reactjs"
    },
    {
      "skillname": "nodejs"
    },
    {
      "skillname": "express"
    },
    {
      "skillname": "mongoodb"  
     },
     {
      "skillname": "tailwindcss"
     },
      {
      "skillname": "bootstrap"
      },
     {
      "skillname": "Github"
    },
  ],
    "portfolio": [
      {
        "name": "Voxa Blog",
        "description": "https://github.com/Mansi226-ux/Voxa",
        "imgurl": "images/Voxa.png.png"   
     },
      {
        "name": "Excel Analytics Platform",
        "description": "https://github.com/Mansi226-ux/Excel_Analytic",
        "imgurl": "images/Surfacechart.png.png"
      },
      {
        "name": "E-commerce Website",
        "description": "https://github.com/Mansi226-ux/E-commerce",
        "imgurl": "images/portfolio/ecommerceimg.avif"
      },
      {
        "name": "Job-Posting Platform",
        "description": "https://github.com/Mansi226-ux/Job-Hunt",
        "imgurl": "images/jobpost.webp"
      }
    ],
      "testimonials": [
        {
          "description": "The UI is smooth, responsive, and user-friendly. The attention to detail and use of modern React components really make the interface stand out. Great sense of design and functionality",
          "name": "John Wangdu – Software Engineer at TechNova"
        },
        {
          "description": "I loved the clean layout and fast performance of this project. The transitions and animations feel professional, and the code structure is well-organized. It’s a great example of how React can be used to build elegant user interfaces.",
          "name": "John wangdu – Frontend Developer"
        },
        {
          "description": "I loved the clean layout and fast performance of this project. The transitions and animations feel professional, and the code structure is well-organized. It’s a great example of how React can be used to build elegant user interfaces.",
          "name": "John wangdu – Frontend Developer"
        }
      ]
  }

export default resumeData
